var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMicrosoft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110.955,
    height: 66.827,
    viewBox: "0 0 110.955 66.827",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #000506;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #6f6f6f;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3036",
    "data-name": "Group 3036",
    transform: "translate(-382.412 -1387.628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2150",
    "data-name": "Path 2150",
    className: "cls-1",
    d: "M526.478,1507.4c-.281.081-.454.134-.629.181-1.841.485-2.922-.13-3.011-2v-8.707h3.644v-1.955h-3.644v-4.32l-2.272.734v3.474c0,.048,0,.1,0,.144h-2.434v1.949h2.408v8.6l.014,0c-.006.181-.008.361,0,.542.044,2.058,1.074,3.36,2.825,3.622a4.452,4.452,0,0,0,3.04-.4A4.946,4.946,0,0,0,526.478,1507.4Z",
    transform: "translate(-72.891 -55.298)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2151",
    "data-name": "Path 2151",
    className: "cls-1",
    d: "M613.477,1499.634c-2.232-.5-3.389-.005-5.122,2.584a17.953,17.953,0,0,1-.121-2.68h-2.15c-.007,0-.016,0-.023.008v14.56H608.3c0-2.454,0-4.812,0-7.172a7.887,7.887,0,0,1,.539-3.066c.824-1.993,2.322-2.59,4.439-2.045a.47.47,0,0,0,.2.036Z",
    transform: "translate(-120.11 -60.059)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2152",
    "data-name": "Path 2152",
    className: "cls-1",
    d: "M588.625,1445.576h-2.293V1433.1h-2.409v-1.949h2.434c0-1.108-.062-2.1.012-3.086a4.463,4.463,0,0,1,6.21-3.856v1.874c-2.963-.547-3.849.065-3.894,3.014-.009.581.026.973.067,2.022H592v1.955h-3.371v12.5Z",
    transform: "translate(-108.221 -19.469)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2153",
    "data-name": "Path 2153",
    className: "cls-1",
    d: "M438.624,1453.985h-2.156v-14.332a10.766,10.766,0,0,1,2.156-.115Z",
    transform: "translate(-29.031 -27.878)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2154",
    "data-name": "Path 2154",
    className: "cls-2",
    d: "M382.842,1398.32a1.682,1.682,0,0,1,0-1.141.342.342,0,0,1,.379,0,4,4,0,0,0,2.479.5,1.416,1.416,0,0,0,1.339-.958,1.493,1.493,0,0,0-.422-1.621,11.375,11.375,0,0,0-1.431-1.025,17.134,17.134,0,0,1-1.451-1,2.551,2.551,0,0,1,.779-4.469,4.531,4.531,0,0,1,3.318.1,1.3,1.3,0,0,1,.019,1.17,4.915,4.915,0,0,0-2.245-.42c-.641.119-1.274.311-1.467,1.028a1.593,1.593,0,0,0,.647,1.915c.723.468,1.478.889,2.177,1.39a2.635,2.635,0,0,1,1.329,3,2.476,2.476,0,0,1-2.077,1.907A4.972,4.972,0,0,1,382.842,1398.32Z",
    transform: "translate(-0.165 -0.381)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2155",
    "data-name": "Path 2155",
    className: "cls-2",
    d: "M418.115,1402.14a1.959,1.959,0,0,1-1.223-.034l-2.66-6.976a1.242,1.242,0,0,1,1.26-.1l2.064,5.833,2.139-5.794a1.61,1.61,0,0,1,1.235-.059Z",
    transform: "translate(-17.089 -3.909)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2156",
    "data-name": "Path 2156",
    className: "cls-2",
    d: "M449.172,1395c.946-.115.946-.115,1.307.762a2.086,2.086,0,0,1,2.173-.934c.37.269.206.613.194.94-1.985.224-2.437.718-2.48,2.677-.025,1.13-.024,2.26-.038,3.389,0,.04-.036.079-.058.125-.294.327-.655.163-1.1.148Z",
    transform: "translate(-35.853 -3.831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2157",
    "data-name": "Path 2157",
    className: "cls-2",
    d: "M408.348,1387.767a1.126,1.126,0,0,1,.937-.075v10.452c-.207.269-.527.157-.937.1Z",
    transform: "translate(-13.929)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2158",
    "data-name": "Path 2158",
    className: "cls-2",
    d: "M399.9,1402.116v-6.948c.3-.332.628-.291,1.038-.107v6.976C400.645,1402.316,400.343,1402.238,399.9,1402.116Z",
    transform: "translate(-9.39 -3.917)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2159",
    "data-name": "Path 2159",
    className: "cls-1",
    d: "M437.085,1428.051a1.452,1.452,0,0,1-1.532-1.4,1.532,1.532,0,0,1,3.06-.162A1.505,1.505,0,0,1,437.085,1428.051Z",
    transform: "translate(-28.538 -20.096)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2160",
    "data-name": "Path 2160",
    className: "cls-2",
    d: "M400.019,1387.758a.8.8,0,0,1,.875.728.7.7,0,0,1-.74.792.741.741,0,0,1-.759-.652C399.313,1388.135,399.617,1387.883,400.019,1387.758Z",
    transform: "translate(-9.114 -0.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2161",
    "data-name": "Path 2161",
    className: "cls-1",
    d: "M451.3,1492.923a5.488,5.488,0,0,0-5.467-5.5c-2.25-.156-4.52-.03-6.849-.03v20.193a8.5,8.5,0,0,0,2.41-.126v-7.493a25.642,25.642,0,0,0,4.992-.3A6.264,6.264,0,0,0,451.3,1492.923Zm-5.227,4.54a3.834,3.834,0,0,1-1.056.246c-1.173.031-2.348.012-3.628.012v-8.133a38.848,38.848,0,0,1,4.1.027,3.408,3.408,0,0,1,3.286,3.376C448.946,1495.312,448.037,1496.823,446.078,1497.463Z",
    transform: "translate(-30.384 -53.551)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2162",
    "data-name": "Path 2162",
    className: "cls-1",
    d: "M585.262,1507.246a10.472,10.472,0,0,0-.364-4.3,5.26,5.26,0,0,0-4.244-3.789,6.348,6.348,0,0,0-7.085,3.636,9.488,9.488,0,0,0-.148,7.8,5.1,5.1,0,0,0,2.817,3.006,8.8,8.8,0,0,0,8.064-.691v-2.163a9.286,9.286,0,0,1-3.017,1.36c-3.259.653-6.174-.837-6.067-4.859Zm-10.078-1.981c.453-3,2.64-4.493,4.705-4.2,1.926.276,2.968,1.7,2.943,4.028-.219.229-.505.165-.769.165C579.8,1505.267,577.544,1505.264,575.185,1505.264Z",
    transform: "translate(-102.169 -59.831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2163",
    "data-name": "Path 2163",
    className: "cls-1",
    d: "M478.538,1513.02c.008-2.821,0-5.642.009-8.463a8.709,8.709,0,0,0-.222-1.891,4.132,4.132,0,0,0-3.96-3.508,10.254,10.254,0,0,0-5.815,1.243v2.371a7.909,7.909,0,0,1,4.358-1.684c2.28-.076,3.491,1.365,3.054,3.7-.965.128-1.954.244-2.937.394a10.343,10.343,0,0,0-3.914,1.06,4.253,4.253,0,0,0-1.978,4.582,3.575,3.575,0,0,0,2.774,3.194c2.156.578,4.152.323,5.689-1.53.133-.16.207-.417.5-.384.184.556-.077,1.167.2,1.766a9.618,9.618,0,0,0,2.069.008A1.047,1.047,0,0,0,478.538,1513.02Zm-2.679-3.2a3.811,3.811,0,0,1-3.841,2.458,2.367,2.367,0,0,1-2.494-2.025,2.309,2.309,0,0,1,1.985-2.885,36.928,36.928,0,0,1,4.631-.7A7.885,7.885,0,0,1,475.859,1509.816Z",
    transform: "translate(-45.469 -59.875)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2164",
    "data-name": "Path 2164",
    className: "cls-1",
    d: "M565.595,1446.176c0-.364.026-.729,0-1.091a6.458,6.458,0,0,0-4.634-6.078,7.529,7.529,0,0,0-8.116,2.407,8.794,8.794,0,0,0-1.4,6.239,6.643,6.643,0,0,0,5.868,6.2c3.869.423,6.879-1.363,7.927-4.721A7.815,7.815,0,0,0,565.595,1446.176ZM563.118,1448a4.31,4.31,0,0,1-4.309,3.926,4.543,4.543,0,0,1-4.84-3.7,8.215,8.215,0,0,1,.094-4.037,4.418,4.418,0,0,1,4.983-3.445,4.275,4.275,0,0,1,4.083,4c.082.536.081,1.084.114,1.575C563.2,1446.92,563.2,1447.469,563.118,1448Z",
    transform: "translate(-90.743 -27.419)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2165",
    "data-name": "Path 2165",
    className: "cls-1",
    d: "M507.7,1443.084a5.94,5.94,0,0,0-4.379-4.087,8.819,8.819,0,0,0-2.981-.161,6.548,6.548,0,0,0-6.14,5.275,11.518,11.518,0,0,0-.27,2.3c-.129,4.509,2.74,7.549,7.081,7.54a6.65,6.65,0,0,0,6.86-5.093A9.666,9.666,0,0,0,507.7,1443.084Zm-2.122,5.32a4.194,4.194,0,0,1-4.171,3.576,4.473,4.473,0,0,1-4.71-3.136,7.485,7.485,0,0,1,.067-5.064c.777-2.14,2.468-3.142,4.927-2.973a4.126,4.126,0,0,1,3.886,3.557,6.108,6.108,0,0,1,.222,1.9A7.436,7.436,0,0,1,505.582,1448.4Z",
    transform: "translate(-59.89 -27.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    "data-name": "Path 2166",
    className: "cls-2",
    d: "M437.274,1396.983a3,3,0,0,0-4.893-1.713,4.74,4.74,0,0,0-.838,5.391,3.7,3.7,0,0,0,4.463,1.277c.653-.245,1.113-.6.709-1.4-2.7,1.2-3.968.722-4.417-1.759h4.99A4.368,4.368,0,0,0,437.274,1396.983Zm-4.793.644a1.977,1.977,0,0,1,1.756-2.062c1.069-.061,1.647.563,1.868,2.061Z",
    transform: "translate(-26.123 -3.719)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2400",
    "data-name": "Rectangle 2400",
    className: "cls-1",
    width: 2.216,
    height: 14.652,
    transform: "translate(407.433 1411.455)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2167",
    "data-name": "Path 2167",
    className: "cls-1",
    d: "M384.5,1447.408h.245v-16.33s5.751,12.663,7.4,16.331h1.213c2.356-5.357,7.3-16.616,7.3-16.616l0,16.615h2.329v-20.118H400l-7.285,16.22-7.133-16.22h-3.174v20.118H384.5Z",
    transform: "translate(0 -21.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2168",
    "data-name": "Path 2168",
    className: "cls-1",
    d: "M484.508,1439.264c-2.232-.5-3.389-.005-5.122,2.584a17.949,17.949,0,0,1-.121-2.68h-2.15l-.023.008v14.56h2.241c0-2.454,0-4.812,0-7.172a7.887,7.887,0,0,1,.539-3.066c.824-1.993,2.322-2.59,4.44-2.045a.481.481,0,0,0,.2.036Z",
    transform: "translate(-50.848 -27.638)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2169",
    "data-name": "Path 2169",
    className: "cls-1",
    d: "M458.287,1450.869c-.471.222-1.025.51-1.469.686-2.936,1.16-5.857-.136-6.681-2.985a7.312,7.312,0,0,1,.018-4.17,4.834,4.834,0,0,1,5.123-3.615,9.22,9.22,0,0,1,3.01,1.022v-2.236a8.818,8.818,0,0,0-2.868-.775,7.072,7.072,0,0,0-7.744,5.786,10.352,10.352,0,0,0-.1,3.53,6.982,6.982,0,0,0,10.708,4.735Z",
    transform: "translate(-34.941 -27.468)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2170",
    "data-name": "Path 2170",
    className: "cls-1",
    d: "M535.315,1446.174c-.872-.478-1.8-.848-2.685-1.31a2.459,2.459,0,0,1-1.276-1.174,2.047,2.047,0,0,1,1.794-2.854,7.206,7.206,0,0,1,3.931.861v-2.262c-2.224-.775-4.621-1.031-6.643.41a3.889,3.889,0,0,0,.212,6.542c.533.339,1.12.594,1.68.89.681.36,1.375.7,2.036,1.092a1.835,1.835,0,0,1,.851,2,1.7,1.7,0,0,1-1.418,1.45,5.232,5.232,0,0,1-2.423.051,11.1,11.1,0,0,1-2.591-1.129v2.375a7.536,7.536,0,0,0,5.634.58,3.956,3.956,0,0,0,3.2-3.312C537.911,1448.488,537.195,1447.2,535.315,1446.174Z",
    transform: "translate(-78.592 -27.486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2171",
    "data-name": "Path 2171",
    className: "cls-1",
    d: "M611.187,1446.983c-.281.08-.454.134-.63.18-1.84.486-2.921-.13-3.011-2v-8.707h3.644V1434.5h-3.644v-4.32l-2.272.734v3.474c0,.048,0,.1,0,.144h-2.433v1.949h2.408v8.6l.014,0c-.006.18-.009.361,0,.542.044,2.058,1.074,3.36,2.824,3.623a4.454,4.454,0,0,0,3.041-.4A4.945,4.945,0,0,0,611.187,1446.983Z",
    transform: "translate(-118.383 -22.853)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    "data-name": "Path 2172",
    className: "cls-1",
    d: "M507.029,1499.634c-2.232-.5-3.389-.005-5.122,2.584a17.95,17.95,0,0,1-.121-2.68h-2.15l-.023.008v14.56h2.242c0-2.454,0-4.812,0-7.172a7.888,7.888,0,0,1,.539-3.066c.824-1.993,2.322-2.59,4.439-2.045a.469.469,0,0,0,.2.036Z",
    transform: "translate(-62.942 -60.059)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2173",
    "data-name": "Path 2173",
    className: "cls-1",
    d: "M553.4,1503.991a5,5,0,0,0-.225-1.341,4.28,4.28,0,0,0-3.184-3.383,5.337,5.337,0,0,0-5.475,1.543,10.475,10.475,0,0,1-.859.76v-2.29h-2.158v14.583h2.22c0-2.715,0-5.3,0-7.886a4.934,4.934,0,0,1,1.617-4.027,3.322,3.322,0,0,1,5.552,1.708,6.639,6.639,0,0,1,.176,1.754c.019,2.408.01,4.816.029,7.224,0,.393-.135.817.156,1.2h2.161C553.405,1510.511,553.414,1507.251,553.4,1503.991Z",
    transform: "translate(-85.434 -59.856)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMicrosoft);
export default __webpack_public_path__ + "static/media/logo-microsoft.6043eb59a932dd82f20d55dae6583eb0.svg";
export { ForwardRef as ReactComponent };